<template>
    <div class="layout-people">

        {{ yearFormat }}
        <slot name="header">
            <div class="uk-section uk-section-medium uk-text-center uk-background-muted page-header">
              <div class="uk-light uk-container uk-container-small uk-text-center">

                <router-link :to="parent.link" v-if="parent" class="text-green"><label>{{parent.menuTitle}}</label></router-link>
                <h1 class="uk-margin-small-top">{{page.title}}</h1>

                <slot name="summary">
                    <p class="uk-text-lead" v-if="page.summary">{{page.summary}}</p>
                </slot>

                <template v-if="!loading && years?.length > 1">
                    <ul class="uk-subnav uk-subnav-pill uk-flex-center category-filter uk-margin-medium-top" uk-margin>
                        <li :class="{ 'uk-active': currentYear == 0 }">
                            <a @click="currentYear = 0" :href="href">All years</a>
                        </li>
                        <template v-for="year in years">
                            <li :class="{ 'uk-active': currentYear == year }">
                                <a @click="currentYear = year">{{formattedYear(year)}}</a>
                            </li>
                        </template>
                    </ul>
                </template>
                
                <form class="uk-flex uk-flex-center" uk-grid>
                    <div class="uk-width-2-3@m">
                        <input class="uk-input" v-model="search" placeholder="Filter by keyword..." />
                    </div>
                </form>

                <slot name="subheader"></slot>
            </div>
        </div>
    </slot>
    
    <div class="uk-section uk-background-white uk-section-medium" v-if="!loading && people && people.length">
        <div class="uk-container uk-container-large">

            <div class="uk-grid uk-child-width-1-2@s uk-child-width-1-3@m uk-child-width-1-4@l" uk-grid uk-height-match="target: .summary">
                <div v-for="child in filteredPeople" :key="child.urlSegment" v-if="filteredPeople.length">
                    <PersonCard :person="child" :formatted-year="formattedYear" />
                </div>
                <div v-else>
                    No results found. <a @click="() => { search=''; year = 0; }" v-if="search || year">Reset filters</a>
                </div>
            </div>

        </div>
    </div>

    <div class="uk-padding-large uk-background-white uk-text-center" v-else >
        <i class="uk-margin-small-right" uk-spinner></i> Loading Profiles...
    </div>

</div>
</template>
<script>
import _ from 'lodash'
import gql from 'graphql-tag'

import PersonCard from '../people/PersonCard.vue'

// GraphQL query
const readPageByURLQuery = gql`
    query($url: String!, $offset: Int!) {
        readOnePeoplePage(filter: { fullPath: { eq: $url }}) {
            yearFormat
            people(limit: 50, offset: $offset, sort: { year: DESC }) {
                nodes {
                    title
                    firstName
                    lastName
                    urlSegment
                    subtitle
                    summary
                    link
                    year
                    image {
                        smallSquare
                        mediumSquare
                    }
                }
                pageInfo {
                    hasNextPage
                    totalCount
                }
            }
        }
    }
`

export default {
    props: ['page', 'parent'],
    data() {
        return {
            people: [],
            search: '',
            currentYear: 0,
            yearFormat: 'YYYY',
            currentPage: 0,
            pageCount: 50,
            pageInfo: {},
            loading: true
        }
    },
    components: {
        PersonCard
    },

    apollo: {
        readPageByURL: {
            query: readPageByURLQuery,
            variables() {
                return {
                    url: this.$route.path,
                    offset: this.currentPage*this.pageCount,
                    limit: this.pageCount
                }
            },
            // manual: true,
            // result ({ data, loading }) {
            //     if (!loading) {
            //         this.yearFormat = data.readOnePeoplePage.yearFormat;
            //         this.people = data.readOnePeoplePage.people.nodes;
            //     }
            // },
            update(data) { 
                this.yearFormat = data.readOnePeoplePage.yearFormat;
                if(data.readOnePeoplePage.people.pageInfo.hasNextPage) {
                    this.currentPage++
                }
                else {
                    this.loading = false;
                }
                this.pageInfo = data.readOnePeoplePage.people.pageInfo;
                this.people = this.people.concat(data.readOnePeoplePage.people.nodes)
            }
        }
    },
    computed: {
        years() {
            if (!this.people || !Array.isArray(this.people)) {
                return [];
            }
            return [...new Set(this.people.map(person => person.year).filter(Boolean))].sort((a, b) => b - a);
        },
        filteredPeople() {
            let people = this.people;
            if(this.currentYear > 0) {
                people = people.filter( person => person.year == this.currentYear);
            }
            if(this.search > "") {
                people = people.filter( person => JSON.stringify(person).toLowerCase().includes(this.search.toLowerCase()));
            }
            return _.sortBy(people, [ 'lastName', 'firstName', 'title']);
        }
    },
    methods: {
        formattedYear(y) {
            if(!y) return;
            if(this.yearFormat == "YYYYYY") {
                let year = parseInt(y);
                return `${year}-${((year+1)%100).toString().padStart(2, "0")}`;
            }
            return y;
        }
    }
}
</script>
